import { render, staticRenderFns } from "./sw-captcha-dialog.vue?vue&type=template&id=6a5a4798&scoped=true&"
import script from "./sw-captcha-dialog.vue?vue&type=script&lang=tsx&"
export * from "./sw-captcha-dialog.vue?vue&type=script&lang=tsx&"
import style0 from "./sw-captcha-dialog.vue?vue&type=style&index=0&id=6a5a4798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a4798",
  null
  
)

export default component.exports